module.exports = __webpack_public_path__ + "static/od-kiczu-do-perelki-krotka-historia-klapek-kubota_og-fc6f7dd568d7c285bbf2b89bb1c5860d.png";